import { getErrorLogger } from '@ori/checkout-utils';
import { type TranslationsContext } from '@ori/i18n';

import { defaultTranslations, translationsNamespace, APP_NAME } from '../constants';
import type { AppConfiguration } from '../types';

const logError = getErrorLogger(APP_NAME);

export const getTranslationsProps = ({ currentLanguage, staticApiUrl, tenant, translations }: AppConfiguration) => {
  const result: TranslationsContext = {
    clientFetchConfiguration: {
      baseUrl: staticApiUrl,
      onError: (error) => {
        logError('Error occured while loading translations.', String(error));
      },
      tenant,
    },
    currentLanguage,
    defaultTranslationsWithNamespaces: {
      [translationsNamespace]: defaultTranslations,
    },
    translationsWithNamespaces: translations ? { [translationsNamespace]: translations } : undefined,
  };

  return result;
};
